import React from 'react';
import gridHeaderTemplates from './gridHeaderTemplates';

const mapCellData = (column) => {
  const thContentClasses = `th-content${column.headerCss ? ' ' + column.headerCss : ''}`;
  return (
    <th className="th-base" key={column.columnHeader}>
      <div className={thContentClasses} style={{ width: column.width }}>
        {column.columnHeader}
      </div>
    </th>
  );
};

const GridHeaderCell = (props) => {
  const Template = props.column.headerTemplate && gridHeaderTemplates[props.column.headerTemplate];
  if (Template) {
    return <Template column={props.column} row={props.row} key={props.column.columnHeader} />;
  }

  return mapCellData(props.column);
};

export default GridHeaderCell;



// WEBPACK FOOTER //
// ./src/common/core/grid/GridHeaderCell.jsx